import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export default function BottomSheet({ open, onClose, title, kicker, children, testid, footer }) {
  useEffect(() => {
    if (!open) return;
    document.body.classList.add("orio-chat-open");
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => { document.body.classList.remove("orio-chat-open"); window.removeEventListener("keydown", onKey); };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-[1100] flex items-end sm:items-center justify-center"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid={testid}>
          <div className="absolute inset-0 bg-black/40 backdrop-blur-md" onClick={onClose} />
          <motion.div
            initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 320, damping: 32 }}
            drag="y" dragConstraints={{ top: 0, bottom: 0 }} dragElastic={{ top: 0, bottom: 0.5 }}
            onDragEnd={(_, i) => { if (i.offset.y > 120 || i.velocity.y > 600) onClose(); }}
            className="relative w-full sm:max-w-lg bg-[#FBF7F1] rounded-t-[28px] sm:rounded-[28px] flex flex-col"
            style={{ maxHeight: "92dvh" }}>
            <div className="pt-2.5 pb-1 flex justify-center cursor-grab">
              <div className="h-1.5 w-10 rounded-full bg-[#E5DECF]" />
            </div>
            <div className="px-5 pb-3 flex items-start justify-between gap-3">
              <div className="min-w-0">
                {kicker && <div className="text-[10px] uppercase tracking-[0.22em] text-[#9A9A9A] font-semibold">{kicker}</div>}
                <h3 className="font-display text-2xl leading-tight text-[#1A1A1A] truncate">{title}</h3>
              </div>
              <button onClick={onClose} aria-label="Chiudi" data-testid={`${testid}-close`}
                className="h-9 w-9 shrink-0 rounded-full bg-white border border-[#F0EBE3] flex items-center justify-center">
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-5 pb-6" onPointerDown={(e) => e.stopPropagation()}>
              {children}
            </div>
            {footer && <div className="px-5 pt-3 pb-[calc(16px+env(safe-area-inset-bottom))] border-t border-[#F0EBE3] bg-white rounded-b-[28px]">{footer}</div>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
